import {CleanedLocale, FormatCurrency} from "./types";

const currencies = {
  "en-US": "USD",
  "en-CA": "CAD",
  "fr-CA": "CAD",
};

const extractLang = (locale: string): string => {
  const splitChar = "-";
  return locale.split(splitChar)[0];
};

export const makeFormatCurrency = (locale: CleanedLocale): FormatCurrency => (
  currencyValue,
  currencyOptions
) => {
  const spacesCommas = /(,|\s)/i;
  const cleanedValue =
    typeof currencyValue === "string"
      ? parseFloat(currencyValue.replace(spacesCommas, ""))
      : currencyValue;
  const currency = currencies[locale];
  const formatter = new Intl.NumberFormat(extractLang(locale), {
    style: "currency",
    currency,
    ...currencyOptions,
  });
  return formatter.format(cleanedValue);
};
